import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ModalAlert } from '../../components/modal';
import { BasicTableDiv, TableBar } from '../../components/table/styles';
import { api } from '../../services/axios';

import { ModalAlertDiv } from '../../components/modal/style';

const defaultForm = [{
  id: '',
  schedule: '',
  type: '',
  duplicated: '',
}]

const defaultError = {
  company: false,
  adress: false,
  city: false,
  country: false,
  language: false,
}

const ScheduleTime = () => {
  const url = "core/ajax/config"

  const [showModal, setShowModal] = useState(false)
  const [form, setForm] = useState(defaultForm);
  const [rows, setRows] = useState([]);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    const url = "core/ajax/config"
    api.post(url, {
      type: 'table',
      authx: ''
    })
      .then(function (res) {
        setForm(res.data)
        setRows(res.data)
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createScheduleTime = () => {
    api.post(url, {
      type: 'saveReact',
      table: JSON.stringify(form)
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <TableBar>
      <div className='buttons'>
        <h1>Config lead time</h1>

        <Button onClick={() => {
          createScheduleTime()
          setShowAlert(!showAlert)
        }} variant="contained">Save Changes</Button>
      </div>

      <BasicTableDiv>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} size='medium' aria-label="simple table">

            <TableHead>
              <TableRow>
                <TableCell
                  align={'center'}
                >
                  Type
                </TableCell>
                <TableCell
                  align={'center'}
                >
                  Schedule time
                  (in seconds)
                </TableCell>
                <TableCell
                  align={'center'}
                >
                  Duplicate time
                  (in seconds)
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => {

                return <TableRow>
                  <TableCell align="center" sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                    {row.type}
                  </TableCell>

                  <TableCell align="center" sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                    <TextField size='small' defaultValue={row.schedule} onChange={(e) => {
                      let newForm = form;
                      newForm[index].schedule = e.target.value;
                      setForm(newForm);
                    }}></TextField>
                  </TableCell>

                  <TableCell align="center" sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                    <TextField size='small' defaultValue={row.duplicated} onChange={(e) => {
                      let newForm = form;
                      newForm[index].duplicated = e.target.value;
                      setForm(newForm);
                    }}></TextField>
                  </TableCell>
                </TableRow>
              }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </BasicTableDiv>


      {/* Modal de Alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }}>

        <ModalAlertDiv>

          {alert.status === 'ok' ?
            <>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>
              <p>Schedule Time successfully changed</p>
              <div>
                <Button onClick={() => {
                  setShowAlert(false)
                  setAlert({})
                }} variant="contained">Ok</Button>
              </div>
            </>
            : alert.status !== undefined ?
              <>
                <h1>Error!</h1>
                <p>{alert.msg}</p>
                <Button onClick={() => {
                  setShowAlert(false)
                  setAlert({})
                }} variant="contained" color='warning'>Ok</Button>
              </>
              :
              <>
                <CircularProgress />
                <h1>Saving change...</h1>
                <p>Please wait</p>
              </>}


        </ModalAlertDiv>
      </ModalAlert>
    </TableBar >
  );
}

export default ScheduleTime;